import React from 'react';
import { Text, Button, Flex, VStack } from '@chakra-ui/react';
import { Modal } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';

type KPIRedirectModalProps = {
  isOpen: boolean;
  onContinue: () => void;
  onCancel: () => void;
};

const KPIRedirectModal: React.FC<KPIRedirectModalProps> = ({
  isOpen,
  onCancel,
  onContinue
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      width="25rem"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={6} p={8} textAlign="center">
        <VStack spacing={4}>
          <FontAwesomeIcon fontSize={40} icon={faArrowUpRightFromSquare} />
          <Text textStyle="headingSection">KPI Dashboard</Text>
          <Text textStyle="textContext" color="gray.600">
            You will be redirected to the KPI dashboard in a new tab.
          </Text>
          <Flex
            mt={3}
            alignItems="center"
            justifyContent="space-between"
            w="full"
          >
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onContinue}>
              Continue
            </Button>
          </Flex>
        </VStack>
      </Flex>
    </Modal>
  );
};

export default KPIRedirectModal;
